import TagManager from 'react-gtm-module'

export const gaMapSelect = (_selected) => {
    console.log(_selected);
    const tagManagerArgs = {
        dataLayer: {
            event: 'map',
            mapclick: _selected,
        },
        dataLayerName: 'PageDataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);

};

export const gaPDFDownload = (_filename) => {
    console.log(_filename);
    // console.log(`event: file_download - file_extension: pdf - file_name: ${_filename} - file_url: ${_fileurl}`)
    const tagManagerArgs = {
        dataLayer: {
            event: 'file_download',
            file_extension: 'pdf',
            file_name: _filename,
        },
        dataLayerName: 'PageDataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);
};

export const gaButtonClick = (_category, _action, _location) => {
    const tagManagerArgs = {
        dataLayer: {
            event: 'eventTracking',
            Category: _category,
            Action: _action,
            Label: _location
        },
        dataLayerName: 'PageDataLayer'
    }
    TagManager.dataLayer(tagManagerArgs);
    
};

